module.exports = __webpack_public_path__ + "static/media/SWSCRC1-03.aabcf4b8.mp3";